export default __webpack_public_path__ + "static/media/Chaturbhuj_Temple_Orchha.9a3c632c.jpg";